module.exports = __webpack_public_path__ + "img/like.23f2f70a.png";